import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import img from '../../assets/a.jpg';
import img1 from '../../assets/b.jpg';
import video from '../../assets/typing.mp4';
const Blog = () => {
     //for autoplay the video
     const vidRef=useRef();
   
     useEffect(() => { vidRef.current.play(); },[]);
    return (
        <div>
             <div className="hero min-h-screen">
              
              {/* <video src={video} loop Hidecontrols autoPlay title="typing.mp4"></video> */}
              <video id="videoPlay" ref={ vidRef }  class="w-full embed-responsive overflow-hidden min-h-fit" autoplay loop muted>
                  <source src={video} type="video/mp4"/>
              </video>
              <div className="hero-overlay bg-opacity-60"></div>
              <div className="hero-content text-center text-neutral-content">
                  <div className="">
                  <h1  className="mb-5 text-2xl lg:text-7xl  font-bold">Coming Soon</h1>
                  <button className="btn btn-white"><Link to='/'>Back to Home</Link></button>
                  
                  </div>
              </div>
              </div>
        </div>
    );
};

export default Blog;